module.exports = __webpack_public_path__ + "img/xnydzbanner.a7076306.png";